// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","imageWrapper":"channels__imageWrapper__zOd_8","listsWrapper":"channels__listsWrapper__VZ2g3"};